import { render, staticRenderFns } from "./create-doctor.vue?vue&type=template&id=5705b337&scoped=true"
import script from "./create-doctor.vue?vue&type=script&lang=js"
export * from "./create-doctor.vue?vue&type=script&lang=js"
import style0 from "./create-doctor.vue?vue&type=style&index=0&id=5705b337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5705b337",
  null
  
)

export default component.exports